/**
 * Kanban drag-move handler: mission-to-sidebar pointer tracking.
 */

import { useCallback } from 'react';
import {
  isMissionToSidebarDragActive,
  updateMissionToSidebarPointer,
} from '../../../../../utils/missionToSidebarBridge';

/** Resolve screen pointer from a dnd-kit drag event (cursor, not card center). */
export function getKanbanDragPointer(event) {
  const activator = event.activatorEvent;
  if (activator && 'clientX' in activator) {
    return {
      clientX: activator.clientX + event.delta.x,
      clientY: activator.clientY + event.delta.y,
    };
  }

  const translated = event.active?.rect?.current?.translated;
  if (translated) {
    return {
      clientX: translated.left + translated.width / 2,
      clientY: translated.top + translated.height / 2,
    };
  }

  return null;
}

const useDragMoveHandler = () => {
  return useCallback((event) => {
    if (!isMissionToSidebarDragActive()) return;

    const pointer = getKanbanDragPointer(event);
    if (pointer) {
      updateMissionToSidebarPointer(pointer.clientX, pointer.clientY);
    }
  }, []);
};

export default useDragMoveHandler;
